import { render, staticRenderFns } from "./ListagemVeiculos.vue?vue&type=template&id=01516061&scoped=true"
import script from "./ListagemVeiculos.vue?vue&type=script&lang=js"
export * from "./ListagemVeiculos.vue?vue&type=script&lang=js"
import style0 from "./ListagemVeiculos.vue?vue&type=style&index=0&id=01516061&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01516061",
  null
  
)

export default component.exports